var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollDowngrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_475_72)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 38,
    r: 34,
    transform: "rotate(90 46 38)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 38,
    r: 33,
    transform: "rotate(90 46 38)",
    stroke: "url(#paint0_linear_475_72)",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.724 33.4442L46.2765 39.3364L39.829 33.4442C39.1809 32.8519 38.134 32.8519 37.4859 33.4442C36.8379 34.0364 36.8379 34.9932 37.4859 35.5854L45.1133 42.5558C45.7613 43.1481 46.8082 43.1481 47.4563 42.5558L55.0836 35.5854C55.7317 34.9932 55.7317 34.0364 55.0836 33.4442C54.4356 32.8671 53.3721 32.8519 52.724 33.4442Z",
    fill: "#0F0E96"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_475_72",
    x: 0.3,
    y: 0.3,
    width: 91.4,
    height: 91.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_475_72"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_475_72",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_475_72",
    x1: 80,
    y1: 38,
    x2: 12,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollDowngrade);
export default __webpack_public_path__ + "static/media/scrollDowngrade.ab2d507b3e71ac64bbb49220460a2267.svg";
export { ForwardRef as ReactComponent };